import React from "react";
import Button from "../Button";
import Input from "../Input";
import { BaseModal } from "./Modal";

type Props = {
  onSubmit: () => void;
  onClose: () => void;
  isOpen: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputLabel: string;
  buttonLabel: string;
};

const ModalWithInput = ({
  onSubmit,
  onClose,
  onChange,
  isOpen,
  inputLabel,
  buttonLabel,
}: Props) => {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <div className="mt-4">
        <Input
          placeholder="Digite aqui"
          onChange={onChange}
          label={inputLabel}
        />
        <div className="flex flex-row justify-between mt-4">
          <Button
            label="Cancelar"
            type="transparent"
            onClick={onClose}
            classNames="w-full justify-center"
          />
          <Button
            label={buttonLabel}
            onClick={onSubmit}
            classNames="w-full justify-center"
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default ModalWithInput;
